function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Table } from '@rd-web-markets/shared/dist/util';
import { CheckboxCell } from '@rd-web-markets/shared/dist/util/Table/CheckboxCell';
import { InputCell } from '@rd-web-markets/shared/dist/util/Table/InputCell';
import { DeleteButton, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import competentProfessionalsService from '../../services/company/competent_professional.service';
export default function CompetentProfessionalTable(_ref) {
  let {
    competentProfessionals,
    setcompetentProfessionals,
    createcompetentProfessional,
    updatecompetentProfessional,
    onSort,
    headers,
    onFilter
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    id: companyId
  } = useParams();
  const dispatch = useDispatch();
  const [duplicates, setDuplicates] = useState([]);
  useEffect(() => {
    if (!competentProfessionals) return;
    const emails = competentProfessionals.map(a => a.email);
    const count = emails => emails.reduce((result, value) => _objectSpread(_objectSpread({}, result), {}, {
      [value]: (result[value] || 0) + 1
    }), {});
    const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);
    setDuplicates(duplicates(count(emails)).filter(e => e !== '').filter(e => e !== null).filter(e => e !== undefined).filter(e => e !== 'null'));
  }, [competentProfessionals]);
  const updatecompetentProfessionalFromState = useCallback((name, value, body) => {
    const indexInState = competentProfessionals.findIndex(r => r.id === body.id);
    competentProfessionals[indexInState][name] = value;
    competentProfessionals.splice(indexInState, 1, body);
    setcompetentProfessionals([...competentProfessionals]);
  }, [competentProfessionals, setcompetentProfessionals]);
  const updateChanges = useCallback(async competentProfessional => {
    await updatecompetentProfessional(_objectSpread({}, competentProfessional));
  }, [updatecompetentProfessional]);
  const createNew = useCallback(async competentProfessional => {
    await createcompetentProfessional(_objectSpread({}, competentProfessional));
  }, [createcompetentProfessional]);
  if (!competentProfessionals) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const emptycompetentProfessional = {
    id: 'new_res',
    name: '',
    phone: '',
    qualifications: '',
    relevant_experience: '',
    email: '',
    has_advance_access: false
  };
  const addNewcompetentProfessionalRow = () => {
    setcompetentProfessionals([_objectSpread(_objectSpread({}, emptycompetentProfessional), {}, {
      id: "new_res-".concat(Math.round(Math.random() * 1000))
    }), ...competentProfessionals]);
  };
  const deletecompetentProfessional = async competentProfessional => {
    if (window.confirm("Are you sure you want to delete the Competent Professional ".concat(competentProfessional.name))) {
      try {
        await competentProfessionalsService.delete(companyId, competentProfessional.id);
        setcompetentProfessionals(competentProfessionals.filter(r => r.id !== competentProfessional.id));
      } catch (e) {
        dispatch(handleError(e));
      }
    }
  };
  const buildRows = () => {
    const rows = competentProfessionals.map((competentProfessional, index) => {
      const saveProgram = competentProfessional => {
        if (typeof competentProfessional.id === 'string' && competentProfessional.id.includes('new_res')) {
          createNew(competentProfessional);
        } else {
          updateChanges(competentProfessional);
        }
      };
      return {
        data: {
          competentProfessional: competentProfessional
        },
        key: competentProfessional.id,
        columns: [/*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.name,
          fieldName: "name",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.qualifications,
          fieldName: "qualifications",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.relevant_experience,
          fieldName: "relevant_experience",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.email,
          fieldName: "email",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.phone,
          fieldName: "phone",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(CheckboxCell, {
          body: competentProfessional,
          value: competentProfessional.has_advance_access,
          fieldName: "has_advance_access",
          onChange: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(DeleteButton, {
          onClick: () => deletecompetentProfessional(competentProfessional)
        }), /*#__PURE__*/React.createElement(SaveButton, {
          onClick: () => saveProgram(competentProfessional)
        })]
      };
    });
    return rows;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, duplicates.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger"
  }, "Be careful you have created Competent Professionals with the same e-mail address ", duplicates.join(', ')), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("style", null, "\n              .competentProfessionals-Tab-table-header {\n                word-break: break-word;\n              }\n            "), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: buildRows(),
    onFilter: onFilter,
    textFilterQueryStringParamName: "query",
    onSort: onSort,
    opts: {
      headerClass: 'competentProfessionals-Tab-table-header'
    },
    onAddRow: addNewcompetentProfessionalRow,
    addRowTextKey: "add_competentProfessional",
    displayAddRowBelow: false
  }))));
}